import { render } from "./IconList.vue?vue&type=template&id=e0fdb966"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e0fdb966"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e0fdb966', __exports__)) {
    api.reload('e0fdb966', __exports__)
  }
  
  module.hot.accept("./IconList.vue?vue&type=template&id=e0fdb966", () => {
    api.rerender('e0fdb966', render)
  })

}


export default __exports__